import React from "react";
import Language from "../language/language";
import { inject, observer } from "mobx-react";

import "./stylesheets/promptMessage.scss";

@inject("languageStore", "commonStore")
@observer
export default class promptMessage extends React.Component {
  openGuidelines = () => {
    this.props.commonStore.gTag("event", "registrationGuidelines", {
      pageName: "registrationCenter",
      buttonName: "registrationGuidelines-1",
    });
  };
  render() {
    return (
      <div className="prompt-message" style={{ WebkitBoxOrient: "vertical" }}>
        <div
          className="inner-wrap"
          title={this.props.languageStore.getResource(
            this.props.languageStore.lang,
            "COMPLETE_PROMPT_MESSAGE"
          )}
        >
          <Language resource="PROMPT_MESSAGE" />
          <a
            onClick={this.openGuidelines}
            rel="noopener noreferrer"
            href="https://rm-static.djicdn.com/documents/73177/98d35c84379381698210748589863627.pdf"
            target="_blank"
          >
            <Language resource="REGISTRATION_GUIDELINES" />
          </a>
          <Language resource="PERIOD" />
          {/* <br />
          <Language resource="PROMPT_MESSAGE_SECOND" />
          <a rel="noopener noreferrer" href="https://terra-1-g.djicdn.com/b2a076471c6c4b72b574a977334d3e05/RoboMaster赛务资料文件夹/RM2021 其他/RM2021青少年相关/RoboMaster 2021 机甲大师青少年系列赛报名指引 V1.0 （20210308）.pdf" target="_blank">
            <Language resource="REGISTRATION_GUIDELINES_SECOND" />
          </a>
          <Language resource="PERIOD_SECOND" /> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/registrationCenter/promptMessage.js